import { render, staticRenderFns } from "./addicted.vue?vue&type=template&id=1549bbe8&scoped=true&"
import script from "./addicted.vue?vue&type=script&lang=js&"
export * from "./addicted.vue?vue&type=script&lang=js&"
import style0 from "./addicted.vue?vue&type=style&index=0&id=1549bbe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1549bbe8",
  null
  
)

export default component.exports